import React from 'react';

//constants
import { layoutModeTypes } from "../../Components/constants/layout";

const LightDark = ({ layoutMode, onChangeLayoutMode }) => {
    const nextMode = layoutMode === layoutModeTypes.DARKMODE
        ? layoutModeTypes.LIGHTMODE
        : layoutModeTypes.DARKMODE;

    return (
        <div className="ms-1 header-item d-none d-sm-flex">
            <button
                type="button"
                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode"
                aria-label={
                    layoutMode === layoutModeTypes.DARKMODE
                        ? "Passer en mode clair"
                        : "Passer en mode sombre"
                }
                title={
                    layoutMode === layoutModeTypes.DARKMODE
                        ? "Mode clair"
                        : "Mode sombre"
                }
                onClick={() => {
                    onChangeLayoutMode(nextMode);
                    localStorage.setItem("layoutMode", nextMode);
                }}
            >
                <i className="bx bx-moon fs-22" aria-hidden />
            </button>
        </div>
    );
};

export default LightDark;